import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Select, MenuItem, OutlinedInput, FormHelperText, Typography } from '@material-ui/core';

class FormSelect extends React.Component {
  render() {
    const {
      input,
      label,
      meta: { touched, error },
      values,
      colorized,
      ...custom
    } = this.props;

    return (
      <FormControl {...custom} error={touched && error ? true : false} margin="dense" variant="outlined">
        {label ? <Typography variant="caption">{label}</Typography> : null}
        <Select
          labelId="form-select-label"
          id="form-select"
          value={input.value}
          disabled={custom.disabled}
          onChange={event => input.onChange(event.target.value)}
          input={<OutlinedInput id="dropdown" />}
          onBlur={event => input.onBlur(event)}
        >
          {values.map(entry => (
            <MenuItem
              key={entry.value}
              value={entry.value}
              style={colorized ? { backgroundColor: entry.value, color: entry.textColor } : null}
            >
              {entry.name}
            </MenuItem>
          ))}
        </Select>
        {touched && error ? <FormHelperText error>{error}</FormHelperText> : null}
      </FormControl>
    );
  }
}

FormSelect.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array,
  colorized: PropTypes.bool,
};

export default FormSelect;



// WEBPACK FOOTER //
// ./src/components/form/FormSelect.js